<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <lote-titulo-subir-form @success="success"></lote-titulo-subir-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <lote-titulo-subir-form @success="success"></lote-titulo-subir-form>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'lote-titulo-subir-form': require('./LoteTituloSubirForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
